const simplePhoneReg = /^1[3456789]\d{9}$/
const simpleEmailReg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/

/* 用户名校验*/
export function validateUsername(str) {
  return validatePhone(str) || validateEmail(str)
}

export function validatePhone(str) {
  return simplePhoneReg.test(str)
}

export function validateEmail(str) {
  return simpleEmailReg.test(str)
}

/**
 * 验证密码是否符合要求：
 * 长度要求：8-20位
 * 可输入特殊字符、大写英文、小写英文、数字，不允许输入中文。
 * 密码强度：
 * 包含四种：高
 * 包含两种或三种：中
 * 包含一种：低
 */
export function validatePassword(str) {
  let result = 0

  str = str.replace(/[!@#$%^&*()\-_=+`~{}[\]|\\;:"',./<>?]/g, '_') // 替换特殊字符为字符: _

  const isLengthMatch = /^\w{8,20}$/.test(str)
  const hasNum = Number(/\d/.test(str))
  const hasLowerCaseLetter = Number(/[a-z]/.test(str))
  const hasCapitalLetter = Number(/[A-Z]/.test(str))
  const hasSpecial = Number(/_/.test(str))

  if (isLengthMatch) {
    const weight = hasNum + hasLowerCaseLetter + hasCapitalLetter + hasSpecial
    result = [0, 1, 2, 2, 3][weight]
  }
  return result
}
